import { useGet } from '../../../sharedModules/hooks/useQuery';
import { CollectionEmailSendDetail } from '../model';

export function useCollectionEmailSend(id: number | null) {
  return useGet<CollectionEmailSendDetail>({
    url: id ? `/collections/email_sends/${id}` : '',
    enabled: !!id,
  });
}
